import * as React from 'react';
import * as Yup from 'yup';

import Alert from 'antd/es/alert';

import FormikField from '@common/react/components/Forms/FormikField/FormikField';
import { dateValidator, simpleStringValidator } from '@common/react/utils/validationHelpers';
import { Nullable } from '@common/typescript/objects/Nullable';
import { ItemProvider } from '@common/react/components/Core/ItemProvider/ItemProvider';
import { ItemEditor } from '@common/react/components/Core/ItemEditor/ItemEditor';
import loadable from '@common/react/loadable/loadableSettings';

import DatePickerLoader from '@app/components/UI/DatePickerLoader';

import '@app/scss/pages/verification.scss';

const DatePickerReact = loadable(
	() => import(/* webpackChunkName: "CustomDatePickerReact" */ '@common/react/components/UI/DatePickerReact/AdaptiveDatepicker'),
	{ fallback: <DatePickerLoader placeholder="Date..." /> },
);

interface FormValues {
	id: number;
	lastName: string;
	birthDate: Nullable<number>;
}

interface ComponentProps {
	afterSubmit: (item) => void;
	emailCode: string;
	phoneCode: string;
	token: string;
}

const validationSchema = Yup.object().shape({
	lastName: simpleStringValidator,
	birthDate: dateValidator,
});

const Verification: React.FC<ComponentProps> = ({
	afterSubmit,
	emailCode,
	phoneCode,
	token,
}) => {
	return (
		<div className="verification-container">
			<div className="contact-text">
				<Alert
					message={<>
						Verify who you are: fill your last name and date of birth.
					</>}
					type="info"
				/>
			</div>
			<br />
			<ItemProvider<FormValues>
				id={-1}
				saveRequest="verification"
				add={{
					lastName: '',
					birthDate: null,
				}}
				clearForSubmit={({ item }) => ({
					...item,
					emailCode,
					phoneCode,
					token,
				})}
				validationSchema={validationSchema}
			>
				<ItemEditor<FormValues>
					afterSubmit={({ res }) => afterSubmit(res)}
					saveText="Verify"
					withButtons
					edit={() => (<>
						<div className="row">
							<FormikField
								containerClassName="form-group col-sm-12"
								fieldName="lastName"
								title="Last Name*"
							/>
						</div>
						<div className="row">
							<FormikField
								fieldName="birthDate"
								title="Birth Date*"
								withValidIndicator
								containerClassName="form-group col-sm-12"
								render={({ field, form }) => (
									<DatePickerReact
										placeholder="Select date"
										value={field.value}
										onChange={(date) => form.setFieldValue(field.name, date)}
										datePickerProps={{
											id: 'birthDate',
											maxDate: new Date(),
											showMonthDropdown: true,
											showYearDropdown: true,
											dropdownMode: 'select',
										}}
										utc
									/>
								)}
							/>
						</div>
					</>)}
				/>
			</ItemProvider>
		</div>
	);
};

export default Verification;
